

export {default as SplashScreen} from './0.Check/SplashScreen';
export {default as TestScreen} from './0.Check/CheckCompletion';

export { default as OnboardingSlider } from './0.Check/OnboardingSlider';

export {default as EmailLogin} from './1.Auth/Email';
export {default as OtpLogin} from './1.Auth/Otp';

export {default as Dashboard} from './2.Dashboard/Dashboard';

export {default as Accounts} from './4.ChartOfAccount/Accounts';
export {default as AccountCreate} from './4.ChartOfAccount/AccountCreate';

export {default as Taxes} from './5.Tax/Taxes';

export {default as ProductsServices} from './6.ProductService/ProductsServices';
export {default as NonInventoryProductServiceCreate} from './6.ProductService/NonInventoryProductServiceCreate';
export {default as InventoryProductCreate} from './6.ProductService/InventoryProductCreate';

export {default as Documents} from './8.Document/Documents';
export {default as EstimateCreate} from './8.Document/EstimateCreate';
export {default as DocumentView} from './8.Document/DocumentView';

export {default as Contacts} from './3.Contact/Contacts';
export {default as ContactView} from './3.Contact/ContactView';
export {default as ContactCreate} from './3.Contact/ContactCreate';

export {default as StatementIncome} from './9.FinancialStatement/StatementIncome';
export {default as StatementBalanceSheet} from './9.FinancialStatement/StatementBalanceSheet';

export {default as BusinessCreate} from './10.Business/BusinessCreate';

export {default as Subscriptions} from './11.Subscription/Subscriptions';

export {default as More} from './12.Other/More';
